import { c as _c } from "react/compiler-runtime";
import React from "react";
import { FaAsterisk, FaHashtag } from "react-icons/fa6";
import { cx } from "@/lib/tailwind-utils";
const KEYPAD_BUTTONS: {
  dtmf: string;
  letters?: string;
  icon?: React.ComponentType<{
    className?: string;
  }>;
}[] = [{
  dtmf: "1",
  letters: ""
}, {
  dtmf: "2",
  letters: "ABC"
}, {
  dtmf: "3",
  letters: "DEF"
}, {
  dtmf: "4",
  letters: "GHI"
}, {
  dtmf: "5",
  letters: "JKL"
}, {
  dtmf: "6",
  letters: "MNO"
}, {
  dtmf: "7",
  letters: "PQRS"
}, {
  dtmf: "8",
  letters: "TUV"
}, {
  dtmf: "9",
  letters: "WXYZ"
}, {
  dtmf: "*",
  icon: FaAsterisk
}, {
  dtmf: "0",
  letters: "+"
}, {
  dtmf: "#",
  icon: FaHashtag
}];
interface DtmfKeypadProps {
  onSendDigits: (digits: string) => Promise<void>;
  disabled?: boolean;
}
const DtmfKeypad: React.FC<DtmfKeypadProps> = t0 => {
  const $ = _c(5);
  const {
    onSendDigits,
    disabled
  } = t0;
  let t1;
  if ($[0] !== disabled || $[1] !== onSendDigits) {
    t1 = KEYPAD_BUTTONS.map(t2 => {
      const {
        dtmf,
        letters,
        icon: Icon
      } = t2;
      return <button key={dtmf} type="button" onClick={() => onSendDigits(dtmf)} disabled={disabled} className="aspect-square h-12 w-12 rounded-full border border-border bg-muted text-center font-medium text-foreground shadow-sm transition-all hover:bg-muted hover:shadow-md active:scale-95 disabled:cursor-not-allowed disabled:opacity-50 disabled:active:scale-100"><div className={cx("flex h-full items-center justify-center", letters && !Icon ? "flex-col" : "")}>{Icon ? <Icon className="text-lg" /> : <><span className="text-lg leading-none">{dtmf}</span>{letters && <span className="mt-0.5 text-micro leading-none text-muted-foreground">{letters}</span>}</>}</div></button>;
    });
    $[0] = disabled;
    $[1] = onSendDigits;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="flex-shrink-0"><div className="grid grid-cols-3 gap-2">{t1}</div></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default DtmfKeypad;